import { put, call, all } from "redux-saga/effects";
import {
  saveSongFailure,
  saveSongSuccess,
} from "../actions/songactions";
import { reportError, reportSuccess } from "../actions/erroractions";
import { saveSongAPI } from "../api/SaveSongCall";

export function* saveSongSaga(action) {
  const orgUniqueName = action.song.uniqueName
  try {
    const firstSave = action.song.localOnly;
    const newUniqueName = isNumber(action.song.uniqueName) ? "NONE" : action.song.uniqueName

    const result = yield call(saveSongAPI, action, newUniqueName);

    if (result.ok) {
      yield all([
        put(
          saveSongSuccess(
            result.songFilename,
            result.sampleStartByte,
            result.sampleEndByte,
            result.duration,
            result.fileSize,
            result.uniqueName,
            result.dateCreated,
            result.reviewInformation.reviewState.status,
            result.url,
            result.ttl,
            firstSave,
            orgUniqueName
          )
        ),
        put(reportSuccess("Successfully saved song")),
      ]);
    } else {
      yield all([
        put(saveSongFailure(orgUniqueName)),
        put(reportError(result.message)),
      ]);
    }
  } catch (e) {
    yield all([
      put(saveSongFailure(orgUniqueName)),
      put(reportError("Unable to reach server" + e)),
    ]);
  }
}

function isNumber(value) {
  return value !== null && !isNaN(value);
}